module.exports = require("readline");